






import Class from './chart-tone-bar';
export default Class;
